"use strict";
// Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * [[MeetingSessionURLs]] contains the URLs that will be used to reach the
 * meeting service.
 */
var MeetingSessionURLs = /** @class */ (function () {
    function MeetingSessionURLs() {
        /**
         * The audio host URL of the session
         */
        this._audioHostURL = null;
        /**
         * The screen data URL of the session
         */
        this._screenDataURL = null;
        /**
         * The screen sharing URL of the session
         */
        this._screenSharingURL = null;
        /**
         * The screen viewing URL of the session
         */
        this._screenViewingURL = null;
        /**
         * The signaling URL of the session
         */
        this._signalingURL = null;
        /**
         * The TURN control URL of the session
         */
        this._turnControlURL = null;
        /**
         * Function to transform URLs. Use this to rewrite URLs to traverse proxies.
         * The default implementation returns the original URL unchanged.
         */
        this.urlRewriter = function (url) {
            return url;
        };
    }
    Object.defineProperty(MeetingSessionURLs.prototype, "audioHostURL", {
        /**
         * Gets the audio host URL after applying the urlRewriter function.
         */
        get: function () {
            return this.urlRewriter(this._audioHostURL);
        },
        /**
         * Sets the raw audio host URL.
         */
        set: function (value) {
            this._audioHostURL = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeetingSessionURLs.prototype, "screenDataURL", {
        /**
         * Gets the screen data URL after applying the urlRewriter function.
         */
        get: function () {
            return this.urlRewriter(this._screenDataURL);
        },
        /**
         * Sets the raw screen data URL.
         */
        set: function (value) {
            this._screenDataURL = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeetingSessionURLs.prototype, "screenSharingURL", {
        /**
         * Gets the screen sharing URL after applying the urlRewriter function.
         */
        get: function () {
            return this.urlRewriter(this._screenSharingURL);
        },
        /**
         * Sets the raw screen sharing URL.
         */
        set: function (value) {
            this._screenSharingURL = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeetingSessionURLs.prototype, "screenViewingURL", {
        /**
         * Gets the screen viewing URL after applying the urlRewriter function.
         */
        get: function () {
            return this.urlRewriter(this._screenViewingURL);
        },
        /**
         * Sets the raw screen viewing URL.
         */
        set: function (value) {
            this._screenViewingURL = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeetingSessionURLs.prototype, "signalingURL", {
        /**
         * Gets the signaling URL after applying the urlRewriter function.
         */
        get: function () {
            return this.urlRewriter(this._signalingURL);
        },
        /**
         * Sets the raw signaling URL.
         */
        set: function (value) {
            this._signalingURL = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeetingSessionURLs.prototype, "turnControlURL", {
        /**
         * Gets the TURN control URL after applying the urlRewriter function.
         */
        get: function () {
            return this.urlRewriter(this._turnControlURL);
        },
        /**
         * Sets the raw TURN control URL.
         */
        set: function (value) {
            this._turnControlURL = value;
        },
        enumerable: true,
        configurable: true
    });
    return MeetingSessionURLs;
}());
exports.default = MeetingSessionURLs;
//# sourceMappingURL=MeetingSessionURLs.js.map